
/* eslint-disable quote-props */
const region1Mapping = {
  '강원특별자치도': '강원도',
  '강원': '강원도',
  '경기': '경기도',
  '경남': '경상남도',
  '경북': '경상북도',
  '광주': '광주광역시',
  '대구': '대구광역시',
  '대전': '대전광역시',
  '부산': '부산광역시',
  '서울': '서울특별시',
  '세종특별자치시': '세종특별자치시',
  '울산': '울산광역시',
  '인천': '인천광역시',
  '전남': '전라남도',
  '전북특별자치도': '전라북도',
  '전북': '전라북도',
  '제주': '제주특별자치도',
  '제주특별자치도': '제주특별자치도',
  '충남': '충청남도',
  '충북': '충청북도',
};

const getRegion1 = (sido) => (sido && region1Mapping[sido]) || '없음';

const getRegion2 = (sido, sigungu) => {
  if (sido === '세종특별자치시') {
    return '세종시';
  }
  return (sigungu && sigungu.replace(/ /gi, '　')) || '없음'; // 공백 대신 기호로 대체
};

const getRegion3 = (bname) => bname || '없음';

const getRegions = ({ sido, sigungu, bname }) => {
  return {
    region1: getRegion1(sido),
    region2: getRegion2(sido, sigungu),
    region3: getRegion3(bname),
  };
};

export default { getRegions };
